export interface BackgroundShellCompletion {
  shellId: string
  status: 'completed' | 'failed'
}

const DETACHED_SHELL_ID_PATTERN = /\bDetached shell\s+([^\s<]+)\s+has\b/i
const EXIT_CODE_PATTERN = /\b(?:completed|exited) with exit code (\d+)\b/i
const SYSTEM_NOTIFICATION_PATTERN = /^\s*<system_notification(?:\s[^>]*)?>[\s\S]*<\/system_notification>\s*$/i

// Do not reuse isSystemNotificationMessage: its text fallback cannot establish authorship and could hide quoted user text.
export function isSystemAuthoredMessage(message: {origin?: {kind?: string}} | undefined): boolean {
  return message?.origin?.kind === 'systemNotification'
}

export function isSystemNotificationMessage(message: {text?: string; origin?: {kind?: string}} | undefined): boolean {
  return (
    message?.origin?.kind === 'systemNotification' ||
    (message !== undefined &&
      message.origin?.kind === undefined &&
      message.text !== undefined &&
      SYSTEM_NOTIFICATION_PATTERN.test(message.text))
  )
}

function extractShellId(text: string): string | undefined {
  const marker = '(shellId:'
  const markerStart = text.toLowerCase().indexOf(marker.toLowerCase())
  if (markerStart !== -1) {
    const valueStart = markerStart + marker.length
    const valueEnd = text.indexOf(')', valueStart)
    if (valueEnd !== -1) {
      const shellId = text.slice(valueStart, valueEnd).trim()
      if (shellId) return shellId
    }
  }

  return text.match(DETACHED_SHELL_ID_PATTERN)?.[1]?.trim()
}

export function parseBackgroundShellNotification(text: string | undefined): BackgroundShellCompletion | undefined {
  if (!text || !/\b(?:completed|exited|failed)\b/i.test(text)) return undefined

  const shellId = extractShellId(text)
  if (!shellId) return undefined

  const exitCode = text.match(EXIT_CODE_PATTERN)?.[1]
  const failed = /\bfailed\b/i.test(text) || (exitCode !== undefined && exitCode !== '0')
  return {shellId, status: failed ? 'failed' : 'completed'}
}
